import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20 4v5l-9 7l-4 4l-3 -3l4 -4l7 -9l5 0","key":"svg-0"}],["path",{"d":"M6.5 11.5l6 6","key":"svg-1"}]]

/**
 * IconSword
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItc3dvcmQiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTIwIDR2NWwtOSA3bC00IDRsLTMgLTNsNCAtNGw3IC05bDUgMCIgLz4KICA8cGF0aCBkPSJNNi41IDExLjVsNiA2IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/sword
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconSword = createReactComponent('outline', 'sword', 'Sword', __iconNode);

export default IconSword;